import { Alert } from '@bi-digital/react';
import { useProductPageContext } from '../../../context/ProductPageContext';
import { Apply } from '../Apply/Apply';
import { ProductInfo } from '../ProductInfo/ProductInfo';
import styles from './ProductPageApp.module.css';

export const ProductPageApp = () => {
    const { programme } = useProductPageContext();

    return (
        <>
            <ProductInfo
                loads={programme.loads}
                terms={programme.terms}
                teachingLanguages={[programme.teachingLanguage]}
                campuses={programme.campuses}
                action={<Apply />}
            />
            {programme.applicationAlertMessage && (
                <Alert className={styles.alert} size='large' data-color='warning'>
                    {programme.applicationAlertMessage}
                </Alert>
            )}
        </>
    );
};
